import { useLoggerMutation } from '@queries/useLoggerMutation'

const useLogger = () => {
    const { mutateAsync } = useLoggerMutation()

    const disable =
        typeof window === 'undefined' || process.env.NODE_ENV === 'development'

    return {
        logError: <TData>(message: string, data: TData) => {
            if (disable) {
                console.error(`[Logger:disabled] Log Error`, message, data)
                return
            }
            return mutateAsync({
                data,
                level: 'error',
                message,
            })
        },

        logInfo: <TData>(message: string, data: TData) => {
            if (disable) {
                console.log(`[Logger:disabled] Log Info`, message, data)
                return
            }
            return mutateAsync({
                data,
                level: 'info',
                message,
            })
        },
    }
}

export default useLogger
